import { useCallback } from 'react';
import useHttp from '../http/useHttp';
import useUI from '../context/useUI';

export default function usePatchCustodian() {
  const { showSnackbar } = useUI();
  const { patchDataResponse, patchData } = useHttp();

  const patchCustodian = useCallback(async (model: any) => {
    return await patchData('Entity', model)
      .then((result) => {
        if (result && result.status === 200) {
          showSnackbar(['Entity updated successfully!'], 'success');
          return result.data;
        }
      })
      .catch((err) => {
        showSnackbar(['Entity update failed!'], 'error');
        return null;
      });
  }, []);

  return { data: patchDataResponse?.data ?? null, patchCustodian };
}
